import React, {useEffect, useState} from 'react';
import ApiService from './api/ApiService';
import {Container, Typography} from "@mui/material";
import {renderDocs} from "./utils";

const Documents = () => {
    const [docs, setDocs] = useState([]);
    useEffect(() => {
        const fetchDocs = async () => {
            try {
                const response = await ApiService.getDocs('docs');
                setDocs(response.docs);
            } catch (error) {
                console.log(error);
            }
        };
        fetchDocs();
    }, []);

    return (
        <Container>
            <Typography variant="h5" gutterBottom fontWeight={'bold'} align={'center'}
            sx={{
                mt: 2,
                textTransform: 'uppercase',
            }}>
                Сведения об образовательной организации
            </Typography>

            {renderDocs(docs)}
        </Container>
    );
};

export default Documents;